import { get } from 'lodash';

export const getIsDrillDownFetching = state => get(state, 'tables.isDrillDownFetching');

export default getIsDrillDownFetching;
